import { Button, Modal } from 'semantic-ui-react';
import React from 'react';
import { func, number, string } from 'prop-types';

import styles from './styles.less';
import McNotes from './McNotes';

const FullContentNotesModal = ({ mcCount, reasonTextDisplay, onClose }) => {
  return (
    <Modal open size="small" className={styles.reasonModal}>
      <Modal.Header>Notes for Provider</Modal.Header>
      <Modal.Content scrolling style={{ display: 'flex', flexDirection: 'column', rowGap: 8 }}>
        {mcCount > 0 && <McNotes mcCount={mcCount} />}
        <div className={styles.lastConsultReasonsTitle}>Last consultations’ reasons</div>
        <span
          style={{ whiteSpace: 'pre-line' }}
          dangerouslySetInnerHTML={{ __html: reasonTextDisplay }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={onClose}>
          Back
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

FullContentNotesModal.propTypes = {
  mcCount: number.isRequired,
  reasonTextDisplay: string.isRequired,
  onClose: func.isRequired,
};

export default FullContentNotesModal;
